<template>
    <div class="z-0 inline-block align-middle">
        <div class="flex h-full items-center gap-2 pl-2 text-xs">
            <SvgIcon
                :name="data.service_type_icon_class"
                class="h-5 w-5"
            />
            <span class="text-sm text-muval-gray-1">
                {{ data.service_label }} - {{ data.payment_amount.formatted }}
                <span class="text-xs text-muval-gray-2">
                    <span>(max refund </span>
                    <span v-if="config.auto_card_fee">{{ data.max_refundable.formatted }}</span>
                    <span v-else>
                        {{ data.max_refundable_with_card_fee.formatted }} including card fee
                        {{ data.max_refundable_card_fee.formatted }}
                    </span>
                    <span>)</span>
                </span>
            </span>
        </div>
    </div>
</template>

<script setup>
defineProps({
    data: {
        type: Object,
        required: true,
    },
    config: {
        type: Object,
        default: null,
        required: false,
    },
});
</script>
